(() => {
(function() {
    function Hamburger(hamburgerElementId, contentElementId, openClassName, initiallyOpen) {
        this.open = initiallyOpen || false;
        this.hamburgerElement = document.getElementById(hamburgerElementId);
        this.contentElement = document.getElementById(contentElementId);
        let openElements = function() {
            this.hamburgerElement.classList.add(openClassName);
            this.contentElement.classList.add(openClassName);
            this.contentElement.removeAttribute("tabindex");
            this.contentElement.setAttribute("aria-hidden", "false");
        };
        openElements = openElements.bind(this);
        let closeElements = function() {
            this.hamburgerElement.classList.remove(openClassName);
            this.contentElement.classList.remove(openClassName);
            this.contentElement.tabIndex = -1;
            this.contentElement.setAttribute("aria-hidden", "true");
        };
        closeElements = closeElements.bind(this);
        let applyState = function() {
            if (this.open) openElements();
            else closeElements();
        };
        applyState = applyState.bind(this);
        this.toggleHamburger = function() {
            this.open = !this.open;
            applyState();
        };
        this.hamburgerElement.addEventListener("click", this.toggleHamburger.bind(this));
        applyState();
    }
    let mobileNavHamburger = new Hamburger("header-mobile-hamburger", "main-nav", "active", false);
})();

})();
//# sourceMappingURL=site.js.map
